var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/sendEvent.ts
var sendEvent = (eventName) => {
  window.monetateQ = window.monetateQ || [];
  window.monetateQ.push(["trackEvent", [eventName]]);
};

// src/eventAnalytics.ts
var eventAnalytics = (campaigns) => {
  if (!campaigns || campaigns.length === 0) return;
  const eventableCampaigns = campaigns.map((campaign) => {
    const { id, experienceName, variantLabel } = campaign;
    return {
      id,
      key: experienceName,
      reports: [],
      split: variantLabel
    };
  });
  document.body.dispatchEvent(
    new CustomEvent("dataStateChange", {
      detail: {
        action: "managedImpression",
        campaigns: eventableCampaigns
      }
    })
  );
};

// src/remoteLogger.ts
var remoteLog = (error, attributes = {}) => {
  if (window && window.newrelic) {
    window.newrelic.noticeError(error, attributes);
  }
};

// src/utils.ts
var MONETATE_URL = "https://engine.monetate.net/api/engine/v1/decide/JohnLewis";

// src/writeCampaigns.ts
var writeCampaigns = (experiences) => {
  const campaigns = getCampaigns(experiences);
  if (!(campaigns == null ? void 0 : campaigns.length)) {
    return;
  }
  window.jlData = window.jlData || {};
  window.jlData.monetateServer = window.jlData.monetateServer || {};
  const monetateCampaigns = window.jlData.monetateServer.campaigns || [];
  const allCampaigns = monetateCampaigns.concat(campaigns);
  window.jlData = __spreadProps(__spreadValues({}, window.jlData), {
    monetateServer: __spreadProps(__spreadValues({}, window.jlData.monetateServer), {
      campaigns: allCampaigns
    })
  });
};
var getCampaigns = (experiences) => {
  if (!experiences) {
    return [];
  }
  return experiences.map((experience) => ({
    key: experience.experienceName,
    reports: [],
    split: experience.variantLabel,
    parameters: experience.parameters
  }));
};

// src/recordImpression.ts
var getMatchingExperiences = (experiences, options) => {
  return experiences.filter((experience) => experience.impressionId).filter((experience) => {
    const paramOptions = options;
    if (paramOptions.paramKey && paramOptions.paramValue) {
      return experience.parameters && experience.parameters[paramOptions.paramKey] === paramOptions.paramValue;
    }
    return experience.experienceName.includes(
      options.experienceName
    );
  });
};
var getImpressionIds = (experiences) => {
  return experiences.map(({ impressionId }) => impressionId);
};
var recordImpression = (channel, experiences, options, monetateId) => __async(null, null, function* () {
  if (!channel) {
    throw new Error(`recordImpression: channel is required`);
  }
  if (!monetateId) {
    console.log(`MonetateId is missing`);
    return;
  }
  const impressionExperiences = getMatchingExperiences(experiences, options);
  const impressions = getImpressionIds(impressionExperiences);
  if (impressions.length === 0) {
    console.log(`No Impressions found for ${JSON.stringify(options)}`);
    return;
  }
  try {
    const response = yield fetch(MONETATE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        channel,
        monetateId,
        events: [
          {
            eventType: "monetate:record:Impressions",
            impressionIds: impressions,
            includeReporting: true
          }
        ]
      })
    });
    writeCampaigns(impressionExperiences);
    eventAnalytics(impressionExperiences);
    console.log(
      `Successfully recorded the impression for ${JSON.stringify(options)}`
    );
  } catch (error) {
    const logData = {
      impressions,
      monetateId,
      message: error.message
    };
    remoteLog(
      new Error(`Failed to record impression: ${error.message}`),
      logData
    );
    console.error("Error recording impression:", error);
  }
});
var recordImpressionByName = (channel, experiences, experienceName, monetateId) => recordImpression(channel, experiences, { experienceName }, monetateId);
var recordImpressionByParam = (channel, experiences, paramKey, paramValue, monetateId) => recordImpression(channel, experiences, { paramKey, paramValue }, monetateId);
export {
  recordImpressionByName,
  recordImpressionByParam,
  sendEvent
};
//# sourceMappingURL=index.mjs.map